module.exports = {
	"title": "Can you tell us why you didn't complete checkout?",
	"radioOptions": [
		"I wanted to use a shipping method that was not provided.",
		"I wanted to use a payment method that was not available.",
		"The page was too complicated and hard to use.",
		"I did not intend to go to checkout.",
		"I changed my mind based on new details I saw."
	],
	"placeholder": "Optional",
	"textAreaLabel": "If you'd like, please tell us more about your experience.",
	"submit": "Submit"
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/checkout/copy/checkoutSurvey.json
// module id = 2540
// module chunks = 62